// src/services/api.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = {
  request: async (url, method = 'GET', body = null, isFormData = false) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000); // Increased timeout for file uploads

    try {
      const headers = {};
      
      // Don't set Content-Type for FormData (browser will set it with boundary)
      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }

      const token = localStorage.getItem('token');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const config = {
        method,
        headers,
        signal: controller.signal,
      };

      if (body) {
        config.body = isFormData ? body : JSON.stringify(body);
      }

      const response = await fetch(`${API_BASE_URL}${url}`, config);
      clearTimeout(timeoutId);

      const contentType = response.headers.get('content-type');
      let data;
      
      if (contentType && contentType.includes('application/json')) {
        data = await response.json();
      } else {
        data = { 
          status: response.status,
          statusText: response.statusText,
          ok: response.ok
        };
      }

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (err) {
      clearTimeout(timeoutId);
      if (err.name === 'AbortError') {
        throw new Error('Request timeout');
      }
      throw err;
    }
  },

  get: (url) => api.request(url),
  post: (url, body, isFormData = false) => api.request(url, 'POST', body, isFormData),
  put: (url, body, isFormData = false) => api.request(url, 'PUT', body, isFormData),
  delete: (url) => api.request(url, 'DELETE'),
  
  // Special method for file upload
  upload: async (url, formData) => {
    return api.post(url, formData, true);
  }
};

export default api;